import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import SettingsPage from "@/pages/admin/Settings";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/site/PublicLayout";
import DashLayout from "@/components/dash/DashLayout";
import Home from "@/pages/public/Home";
import Programs from "@/pages/public/Programs";
import Register from "@/pages/public/Register";
import Payment from "@/pages/public/Payment";
import Login from "@/pages/public/Login";
import { ForgotPassword, ResetPassword } from "@/pages/public/PasswordRecovery";
import { LegalPage, ContactPage } from "@/pages/public/InfoPages";
import StudentOverview from "@/pages/student/Overview";
import { StudentCourses, StudentCourseDetail } from "@/pages/student/Courses";
import StudentLive from "@/pages/student/LiveClasses";
import StudentExams from "@/pages/student/Exams";
import ExamTake from "@/pages/student/ExamTake";
import ExamReview from "@/pages/student/ExamReview";
import StudentAssignments from "@/pages/student/Assignments";
import StudentAttendance from "@/pages/student/Attendance";
import StudentProfile from "@/pages/student/Profile";
import AdminOverview from "@/pages/admin/Overview";
import PaymentsPage from "@/pages/admin/Payments";
import ResultsPage from "@/pages/admin/Results";
import { UsersPage, PackagesPage, CoursesPage, MaterialsPage, QuestionsPage, ExamsPage, SchedulePage, AnnouncementsPage, AssignmentsPage } from "@/pages/admin/ManagePages";

const adminOnly = (el) => <ProtectedRoute roles={["admin"]}>{el}</ProtectedRoute>;

function App() {
  return (
    <div className="App">
      <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/program" element={<Programs />} />
              <Route path="/daftar" element={<Register />} />
              <Route path="/pembayaran" element={<Payment />} />
              <Route path="/kebijakan-privasi" element={<LegalPage kind="privasi" />} />
              <Route path="/syarat-layanan" element={<LegalPage kind="syarat" />} />
              <Route path="/kontak" element={<ContactPage />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/lupa-sandi" element={<ForgotPassword />} />
            <Route path="/reset-sandi" element={<ResetPassword />} />
            <Route path="/siswa" element={<ProtectedRoute roles={["siswa"]}><DashLayout /></ProtectedRoute>}>
              <Route index element={<StudentOverview />} />
              <Route path="materi" element={<StudentCourses />} />
              <Route path="materi/:id" element={<StudentCourseDetail />} />
              <Route path="kelas" element={<StudentLive />} />
              <Route path="ujian" element={<StudentExams />} />
              <Route path="ujian/:id" element={<ExamTake />} />
              <Route path="hasil/:id" element={<ExamReview />} />
              <Route path="tugas" element={<StudentAssignments />} />
              <Route path="absensi" element={<StudentAttendance />} />
              <Route path="profil" element={<StudentProfile />} />
            </Route>
            <Route path="/admin" element={<ProtectedRoute roles={["admin", "pengajar"]}><DashLayout /></ProtectedRoute>}>
              <Route index element={<AdminOverview />} />
              <Route path="pengguna" element={adminOnly(<UsersPage />)} />
              <Route path="paket" element={adminOnly(<PackagesPage />)} />
              <Route path="pembayaran" element={adminOnly(<PaymentsPage />)} />
              <Route path="pengaturan" element={adminOnly(<SettingsPage />)} />
              <Route path="kurikulum" element={<CoursesPage />} />
              <Route path="materi" element={<MaterialsPage />} />
              <Route path="bank-soal" element={<QuestionsPage />} />
              <Route path="ujian" element={<ExamsPage />} />
              <Route path="tugas" element={<AssignmentsPage />} />
              <Route path="jadwal" element={<SchedulePage />} />
              <Route path="pengumuman" element={<AnnouncementsPage />} />
              <Route path="hasil" element={<ResultsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
